<template>
  <Detail :businessInfo="businessInfo" />
</template>
<script>
import Detail from "../detail.vue";
import { softwareByProductApi } from "@/api/website.js";
import { prefix } from "@/utils/env";
export default {
  name: "digital-airoad",
  components: {
    Detail,
  },
  data() {
    return {
      businessInfo: {
        name: "AIRoad",
        icon: require("@/assets/images/digitalImg/airoad_icon.png"),
        bgImg: require("@/assets/images/digitalImg/airoad_bg.png"),
        banner: {
          icon: require("@/assets/images/digitalImg/airoad_icon.png"),
          title:
            "AIRoad : Double the Bidding Efficiency, Halve the Design Cost",
          subTitle: "Road Engineering Schematic Design System",
          downloadBtnList: [
            {
              label: "Download",
              fileUrl: "",
              fileName: "AIRoad",
            },
          ],
          posterImg: require("@/assets/images/digitalImg/video_airoad.png"),
          videoUrl: `${prefix}/static/video/airoad2024_en.mp4`,
        },
        all: {
          title: "What is AIRoad？",
          content:
            "AIRoad relies on its independently developed BIM engine, and uses GIS, photogrammetry, and remote sensing data to construct digital terrain, quickly realizing parameterized and intelligent design. Through dynamic interactive routing, it automatically constructs solution models. By continuously leveraging AI large language models and content generation technology, AIRoad enhances design efficiency in creative solutions, effect expression, and drawing assistance. It can improve the efficiency of solution design by 8–10 times and the comprehensive efficiency of solution design by 20–30%.",
          imgLists: [
            {
              id: 1,
              title: "Symmetrical Double-Loop Cloverleaf Interchange（1/3）",
              img: require("@/assets/images/digitalImg/airoad_img1.png"),
            },
            {
              id: 2,
              title:
                "Diagonal Quadrant Dual-Loop Cloverleaf Interchange（2/3）",
              img: require("@/assets/images/digitalImg/airoad_img2.png"),
            },
            {
              id: 3,
              title: "Type-A Trumpet Interchange for T-Junctions（3/3）",
              img: require("@/assets/images/digitalImg/airoad_img3.png"),
            },
          ],
        },
        highlights: {
          title: "Why Choose AIRoad？",
          lists: [
            {
              id: 1,
              icon: require("@/assets/images/digitalImg/airoad_icon1.png"),
              title: "Fast Solution Layout",
              content:
                "Automatically layout the design through simple parameter input. Designers can quickly edit and modify relevant content with just a click and drag of the mouse, achieving one-click operation.",
            },
            {
              id: 2,
              icon: require("@/assets/images/digitalImg/airoad_icon2.png"),
              title: "Multi-disciplinary Collaboration",
              content:
                "The software includes interoperable designs for interchanges, bridges, tunnels, intersections, and other specialties, and integrates with VRRoad.",
            },
          ],
        },

        function: {
          title: "AIRoad Features",
          lists: [
            {
              id: 1,
              img: require("@/assets/images/digitalImg/function01.png"),
              title: "Based on 3D Scene Design",
              content:
                "The system supports the integrated management of project satellite images, terrain maps, and other control factors, including the import and export of terrain and object data. It designs based on a 3D scene, automatically creating a 3D road model that meets the design input requirements for feasibility and solution research stages. Modeling speed is improved by more than 10 times, and overall design efficiency is increased by 30%.",
            },
            {
              id: 2,
              img: require("@/assets/images/digitalImg/function02.png"),
              title: "Quick Completion of Interchange Design",
              content:
                "Using the EICAD modeling approach, it offers automatic routing, automatic longitudinal grade generation, and automatic interchange connection design. It allows for fast interchange design and supports dynamic dragging and double-click modification, with intuitive and convenient interaction.",
            },
            {
              id: 3,
              img: require("@/assets/images/digitalImg/function03.png"),
              title:
                "Real-time Interaction Between Entities,\nMulti-disciplinary Fast Design",
              content: [
                "In bridge design, the substructures and superstructures adopt a parametric design concept. By specifying components and start/end points, the system automatically creates the bridge model. It utilizes connection techniques between bridge and road models, including pavement, roadbed, and slopes, enabling collaborative design across disciplines such as bridges, roads, and digital models.",
                'In tunnel design, it can quickly create tunnel models, determining the start and end station numbers based on geological longitudinal profiles. It supports rapid longitudinal design and quick adjustments to the solution. Tunnel entrance designs use a combination of data input and graphical interaction, offering a "what you see is what you get" experience.',
                "For intersection road network design, the software supports one-click generation of road network intersection entities. After automatic road model updates, all intersection models are generated, greatly improving efficiency.",
                "In culvert design, it is based on a universal drawing to design circular pipe culverts, box culverts, and slab culverts. It integrates with EICAD for culvert layout diagrams and engineering quantity statistics. The software also allows bulk import of culvert tables via Excel and offers a more intuitive 3D view for culvert layout.",
              ],
            },
          ],
        },
        support: {
          title: "AIRoad User Support",
          documnentUrl: "/download?type=manual",
          videosUrl: "/academy?type=AIRoad",
        },
        contact: {
          bgImg: require("@/assets/images/digitalImg/airoad_contactbg.png"),
          title: "Get AIRoad Now!",
          subTitle:
            "Delauney Digital Design Software Line provides you with a one-stop design solution.",
          firstBtnText: "Download Software",
          firstBtnUrl: "",
          secondBtnText: "Contact Sales Representative",
          secondBtnUrl: "",
        },
        combination: {
          title:
            "Enhance your workflow by integrating AIRoad with other software.",
          lists: [
            {
              id: 1,
              img: require("@/assets/images/digitalImg/airoad_combination01.png"),
              title: "Used AIRoad to complete the ",
              subTitle:
                "Xinyang Expressway Suqian Hub to Huanghuatang Hub Section Expansion Project",
              content:
                "Projects used AIRoad for route design and feasibility study reporting.",
            },
            {
              id: 2,
              img: require("@/assets/images/digitalImg/airoad_combination02.png"),
              title: "Used AIRoad to complete the ",
              subTitle:
                "Shenhai Line Zhangzhou Longhai to Zhao’an Section Expansion Project – Pantuo Interchange",
              content:
                "Projects used AIRoad for route design and feasibility study reporting.",
            },
            {
              id: 3,
              img: require("@/assets/images/digitalImg/airoad_combination03.png"),
              title: "Used AIRoad to complete the ",
              subTitle: "Shenyang Metropolitan Ring Expressway Yilu Hub",
              content:
                "Projects used AIRoad for route design and feasibility study reporting.",
            },
          ],
          softwares: [
            {
              name: "EICAD",
              icon: require("@/assets/images/digitalImg/eicad_icon2.png"),
              desc: "A comprehensive digital design software suite containing modules for various disciplines such as field survey, digital terrain model, routes, interchanges, embankments and pavements, bridges and culverts, tunnels, traffic engineering, drainage systems, and more.",
            },
          ],
        },
      },
    };
  },
  created() {
    this.getSoftware();
  },
  methods: {
    async getSoftware() {
      await softwareByProductApi({ productId: "1" }).then((res) => {
        if (res.code === 200) {
          if (res.data.length > 0 && res.data[0].pathUrlIdList.length > 0) {
            this.businessInfo.banner.downloadBtnList[0].fileUrl =
              res.data[0].pathUrlIdList[0].path;
            this.businessInfo.banner.downloadBtnList[0].fileName =
              res.data[0].pathUrlIdList[0].fileTitle;
          } else {
            this.businessInfo.banner.downloadBtnList[0].fileUrl = "";
            this.businessInfo.banner.downloadBtnList[0].fileName = "";
          }
        }
      });
    },
  },
};
</script>
